const types = [
  {
    name: 'simple',
    label: 'Simple',
  },
  {
    name: 'pipeline_experiment',
    label: 'Pipeline Experiment',
  },
  {
    name: 'destination',
    label: 'Destination Experiment',
  },
];

export default types;
